<template>
  <div class="churn-step-1">
    <div class="top-icon">
      <img class="churn-icon" :src="require('@/assets/churn/churn-icon.svg')">
    </div>
    <div class="title">חבל לנו שהחלטת לעזוב</div>
    <div class="text">אנחנו פה בשבילך ונשמח לעזור לך בכל דרך לקבל ערך מהשירות שלנו</div>
    <div class="buttons">
      <riseup-button class="first-button chat-with-cx-button"
                     :action="chatWithCx"
                     title="לדבר עם הצוות"
                     variant="primary"
                     :icon="require('@/assets/intercom_chat_icon.svg')"
                     size="slim"/>
      <riseup-button :action="approve"
                     title="למחיקת החשבון"
                     variant="danger"
                     size="slim"/>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import Intercom from '@/Intercom';

const INTERCOM_MESSAGE = `הי,
חשבתי לעזוב את השירות. לפני שאני עושה את זה, רציתי לדבר אתכם על:
`;

export default {
  name: 'ChurnStep1',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  methods: {
    approve() {
      Segment.trackUserInteraction('ChurnStep1_ApproveClicked');
      this.nextStep();
    },
    chatWithCx() {
      Segment.trackUserInteraction('ChurnStep1_ChatWithCxClicked');
      this.close();
      Intercom.showNewMessage(INTERCOM_MESSAGE);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.churn-step-1 {
  text-align: center;

  .top-icon {
    margin-top: 26px;
    margin-bottom: 40px;

    .churn-icon {
      height: 78px;
    }
  }

  .title {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: bold;
  }

  .text {
    margin-bottom: 36px;
    font-size: 18px;
    line-height: 24px;
  }

  .buttons {
    .first-button {
      margin-bottom: 16px;
    }
  }
}
</style>
